import type { UploadedFileAnswer } from '../../submitSurvey/types';
import type { LogicAnswerValue } from '../types';

function isNonEmptyString(value: LogicAnswerValue): value is string {
  return typeof value === 'string' && value !== '';
}

/** MCQ answers → option id list (single- or multi-select). */
export function normalizeSelectedOptions(answer: LogicAnswerValue): string[] {
  if (Array.isArray(answer)) {
    const selectedOptions: string[] = [];

    for (const option of answer) {
      if (typeof option === 'string' && option !== '') {
        selectedOptions.push(option);
      }
    }

    return selectedOptions;
  }

  if (isNonEmptyString(answer)) {
    return [answer];
  }

  return [];
}

/** Text answers → string (or undefined when empty). */
export function normalizeText(answer: LogicAnswerValue): string | undefined {
  if (typeof answer === 'string') {
    return answer;
  }

  if (answer !== undefined && answer !== null) {
    return String(answer);
  }

  return undefined;
}

function isUploadedFile(item: unknown): item is UploadedFileAnswer {
  return typeof item === 'object' && item !== null;
}

/** File upload answers → uploaded file objects only. */
export function normalizeFileUpload(answer: LogicAnswerValue): UploadedFileAnswer[] {
  if (!Array.isArray(answer)) {
    return [];
  }

  const files: UploadedFileAnswer[] = [];

  for (const item of answer) {
    if (isUploadedFile(item)) {
      files.push(item);
    }
  }

  return files;
}
